import { currentAdminUserSlice } from "./slices/currentAdminUserSlice";
import { currentCompanyAdminUserSlice } from "./slices/currentCompanyAdminUserSlice";
import { adminUserSlice } from "./features/adminUser/adminUserSlice";
import { notificationSlice } from "./slices/notificationSlice";
import { companySlice } from "./features/company/companySlice";
import { companyAdminUserSlice } from "./features/companyAdminUser/companyAdminUserSlice";
import { companyInvoiceSlice } from "./features/companyInvoice/companyInvoiceSlice";
import { companyPaymentSlice } from "./features/companyPayment/companyPaymentSlice";
import { companyPaymentSummarySlice } from "./features/companyPayment/companyPaymentSummarySlice";
import { promotionSlice } from "./features/promotion/promotionSlice";
import { hotelPromotionSlice } from "./features/hotel/hotelPromotion/hotelPromotionSlice";
import { pageContextSlice } from "./slices/pageContextSlice";
import { hotelSlice } from "./features/hotel/hotelSlice";
import { hotelRoomSlice } from "./features/hotel/hotelRoom/hotelRoomSlice";
import { hotelRoomChildrenSettingSlice } from "./features/hotel/hotelRoom/hotelRoomChildrenSetting/hotelRoomChildrenSettingSlice";
import { hotelPlanSlice } from "./features/hotel/hotelPlan/hotelPlanSlice";
import { hotelPlanChildrenSettingSlice } from "./features/hotel/hotelPlan/hotelPlanChildrenSetting/hotelPlanChildrenSettingSlice";
import { hotelPlanCancelPolicySlice } from "./features/hotel/hotelPlan/hotelPlanCancelPolicy/hotelPlanCancelPolicySlice";
import { hotelRoomPlanSlice } from "./features/hotel/hotelRoomPlanSlice";
import { masterDataSlice } from "./slices/masterDataSlice";
import { hotelCancelPolicySlice } from "./features/hotelCancelPolicy/hotelCancelPolicySlice";
import { hotelChildrenSettingSlice } from "./features/hotel/hotelChildrenSetting/hotelChildrenSettingSlice";
import { hotelQuestionSlice } from "./features/hotel/hotelQuestion/hotelQuestionSlice";
import { hotelFilterSlice } from "./features/hotel/hotelFilter/hotelFilterSlice";
import { hotelMailSlice } from "./features/hotel/hotelMail/hotelMailSlice";
import { hotelOptionSlice } from "./features/hotel/hotelOption/hotelOptionSlice";
import { hotelWaitingListSlice } from "./features/hotel/hotelWaitingList/hotelWaitingListSlice";
import { hotelInventorySlice } from "./features/hotel/hotelInventory/hotelInventorySlice";
import { hotelPriceSlice } from "./features/hotel/hotelPrice/hotelPriceSlice";
import { hotelScriptSlice } from "./features/hotel/hotelScript/hotelScriptSlice";
import { hotelCheckInSlice } from "./features/hotel/hotelCheckIn/hotelCheckInSlice";
import { hotelCheckInQuestionSlice } from "./features/hotel/hotelCheckIn/hotelCheckInQuestion/hotelCheckInQuestionSlice";
import { hotelSpecifiedStaysOnlyPeriodSlice } from "./features/hotel/hotelCalendar/hotelSpecifiedStaysOnlyPeriodSlice";
import { autoTranslationSlice } from "./slices/autoTranslationSlice";
import { bookingSlice } from "./features/booking/bookingSlice";
import { userSlice } from "./features/user/userSlice";
import { newsletterSlice } from "./features/newsletter/newsletterSlice";
import { newsletterTemplateSlice } from "./features/newsletter/newsletterTemplateSlice";
import { hotelPushMessageGroupSlice } from "./features/hotel/hotelPushMessageGroup/hotelPushMessageGroupSlice";
import { objectUrlSlice } from "./slices/objectUrlSlice";
// import { breakpointSlice } from "slices/breakpointSlice";

export type ReduxState = {
  currentAdminUser: typeof currentAdminUserSlice.reducer;
  currentCompanyAdminUser: typeof currentCompanyAdminUserSlice.reducer;
  adminUser: typeof adminUserSlice.reducer;
  notification: typeof notificationSlice.reducer;
  company: typeof companySlice.reducer;
  companyAdminUser: typeof companyAdminUserSlice.reducer;
  companyInvoice: typeof companyInvoiceSlice.reducer;
  companyPayment: typeof companyPaymentSlice.reducer;
  companyPaymentSummary: typeof companyPaymentSummarySlice.reducer;
  promotion: typeof promotionSlice.reducer;
  hotelPromotion: typeof hotelPromotionSlice.reducer;
  pageContext: typeof pageContextSlice.reducer;
  hotel: typeof hotelSlice.reducer;
  hotelRoom: typeof hotelRoomSlice.reducer;
  hotelRoomChildrenSetting: typeof hotelRoomChildrenSettingSlice.reducer;
  hotelPlan: typeof hotelPlanSlice.reducer;
  hotelPlanChildrenSetting: typeof hotelPlanChildrenSettingSlice.reducer;
  hotelPlanCancelPolicy: typeof hotelPlanCancelPolicySlice.reducer;
  hotelRoomPlan: typeof hotelRoomPlanSlice.reducer;
  masterData: typeof masterDataSlice.reducer;
  hotelCancelPolicy: typeof hotelCancelPolicySlice.reducer;
  hotelChildrenSetting: typeof hotelChildrenSettingSlice.reducer;
  hotelQuestion: typeof hotelQuestionSlice.reducer;
  hotelFilter: typeof hotelFilterSlice.reducer;
  hotelMail: typeof hotelMailSlice.reducer;
  hotelOption: typeof hotelOptionSlice.reducer;
  hotelWaitingList: typeof hotelWaitingListSlice.reducer;
  hotelInventory: typeof hotelInventorySlice.reducer;
  hotelPrice: typeof hotelPriceSlice.reducer;
  hotelScript: typeof hotelScriptSlice.reducer;
  hotelCheckIn: typeof hotelCheckInSlice.reducer;
  hotelCheckInQuestion: typeof hotelCheckInQuestionSlice.reducer;
  hotelPushMessageGroup: typeof hotelPushMessageGroupSlice.reducer;
  hotelSpecifiedStaysOnlyPeriod: typeof hotelSpecifiedStaysOnlyPeriodSlice.reducer;
  autoTranslation: typeof autoTranslationSlice.reducer;
  booking: typeof bookingSlice.reducer;
  user: typeof userSlice.reducer;
  newsletter: typeof newsletterSlice.reducer;
  newsletterTemplate: typeof newsletterTemplateSlice.reducer;
  objectUrl: typeof objectUrlSlice.reducer;
  // breakpoint: typeof breakpointSlice.reducer;
};

export const reducers: ReduxState = {
  currentAdminUser: currentAdminUserSlice.reducer,
  currentCompanyAdminUser: currentCompanyAdminUserSlice.reducer,
  adminUser: adminUserSlice.reducer,
  notification: notificationSlice.reducer,
  company: companySlice.reducer,
  companyAdminUser: companyAdminUserSlice.reducer,
  companyInvoice: companyInvoiceSlice.reducer,
  companyPayment: companyPaymentSlice.reducer,
  companyPaymentSummary: companyPaymentSummarySlice.reducer,
  promotion: promotionSlice.reducer,
  hotelPromotion: hotelPromotionSlice.reducer,
  pageContext: pageContextSlice.reducer,
  hotel: hotelSlice.reducer,
  hotelRoom: hotelRoomSlice.reducer,
  hotelRoomChildrenSetting: hotelRoomChildrenSettingSlice.reducer,
  hotelPlan: hotelPlanSlice.reducer,
  hotelPlanChildrenSetting: hotelPlanChildrenSettingSlice.reducer,
  hotelPlanCancelPolicy: hotelPlanCancelPolicySlice.reducer,
  hotelRoomPlan: hotelRoomPlanSlice.reducer,
  masterData: masterDataSlice.reducer,
  hotelCancelPolicy: hotelCancelPolicySlice.reducer,
  hotelChildrenSetting: hotelChildrenSettingSlice.reducer,
  hotelQuestion: hotelQuestionSlice.reducer,
  hotelFilter: hotelFilterSlice.reducer,
  hotelMail: hotelMailSlice.reducer,
  hotelOption: hotelOptionSlice.reducer,
  hotelWaitingList: hotelWaitingListSlice.reducer,
  hotelInventory: hotelInventorySlice.reducer,
  hotelPrice: hotelPriceSlice.reducer,
  hotelScript: hotelScriptSlice.reducer,
  hotelCheckIn: hotelCheckInSlice.reducer,
  hotelCheckInQuestion: hotelCheckInQuestionSlice.reducer,
  hotelPushMessageGroup: hotelPushMessageGroupSlice.reducer,
  hotelSpecifiedStaysOnlyPeriod: hotelSpecifiedStaysOnlyPeriodSlice.reducer,
  autoTranslation: autoTranslationSlice.reducer,
  booking: bookingSlice.reducer,
  user: userSlice.reducer,
  newsletter: newsletterSlice.reducer,
  newsletterTemplate: newsletterTemplateSlice.reducer,
  objectUrl: objectUrlSlice.reducer,
  // breakpoint: breakpointSlice.reducer,
};
